module.exports = {"pt-BR":{"admin":{"components":{"feeField":{"label":"Taxa"}}}}}